/**
 * Contact Customer Sync
 *
 * Fire-and-forget POST to the backend customer endpoint on contact
 * form submit. Never blocks Shopify's native form post.
 * `keepalive: true` is required — without it the browser cancels the
 * request when Shopify navigates away after the form is submitted.
 *
 * The endpoint is public — it is called cross-origin, so there is no App Proxy
 * signature — and is guarded on the backend instead (spam-guard.server.ts in
 * tsk-hp). Two things here are load-bearing for that guard:
 *
 *   - The request is a real cross-origin `fetch`, so the browser sets `Origin`
 *     to the shop's domain. The backend rejects anything without it, which is
 *     what stops a bot posting to Heroku directly.
 *   - The body is the WHOLE form, so the honeypot field — and a Turnstile
 *     token, if that widget is ever added — are forwarded without this file
 *     needing to know about either.
 *
 * Keep it a simple request (form-encoded, no custom headers): anything that
 * triggers a CORS preflight would need the backend to answer OPTIONS too.
 */
(function () {
    const handleSubmit = (event) => {
        const form = event.currentTarget;
        const body = new URLSearchParams(new FormData(form)).toString();
        const url = `${window.BooqableConfig.API_URL}/customers`;

        fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body,
            keepalive: true,
        }).catch((err) => {
            console.warn('[ContactCustomerSync] sync failed (non-blocking):', err);
        });
    };

    document.querySelectorAll('form[data-customer-sync]').forEach((form) => {
        form.addEventListener('submit', handleSubmit);
    });
})();
